import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import {
    FindLoad,
    FindSuccessItem,
    Images,
    noteStatusEnums,
    PermissionList,
    RolePermission,
    useModal,
    User,
    useSecondaryModal,
} from 'utils';
import { CustomDelete, EditWithIcon, ManageActions, MinLoader, NoteHistoryModal } from 'components';
import { RequestNoteUpdate } from './requestNoteUpdate';
import { remindEnums } from './constnats';
import { appointmentActions } from 'store';
import { useNoteEditPermissions } from '../../../../../pages/forms/constants';
import { noteEnums } from '../../../../schedule/core/modals/apptDetail/constants';
import { CreateAppSessionNote } from '../../../../schedule/core/modals/apptDetail/createAppSessionNote';
import { CreateAppFormNote } from '../../../../schedule/core/modals/apptDetail/createAppFormNote';

const REMIND_NOTE_ACTION_TYPE = 'REMIND_APPT_NOTE';
const DELETE_ACTION_TYPE = 'DELETE_APPT_NOTE';

export const ApptNoteActions = ({ afterSuccess = () => {}, item, apptId, reverse, single, appt, serviceTemplate, noteType, }) => {
    const { appt: apptById } = useSelector((state) => ({
        appt: state.appointment.appointmentById,
    }));
    const { userInfo } = User();
    const { open } = useModal();
    const dispatch = useDispatch();
    const loadRequestRemind = FindLoad(REMIND_NOTE_ACTION_TYPE);
    const [remindId, setRemindId] = React.useState(null);
    const remindSuccess = FindSuccessItem(REMIND_NOTE_ACTION_TYPE);
    const [pdfLoading, setPdfLoading] = useState(false);
    const currentAppt = appt || apptById;
    const { canEdit, checkSuperVizer, isUpdateRequest, isLocked, needApproved } = useNoteEditPermissions(item, currentAppt);
    const { openSecondary } = useSecondaryModal();

    useEffect(() => {
        if (remindSuccess && remindId) {
            setRemindId(null);
        }
    }, [remindSuccess]);

    const handleEdit = (handleClose) => {
        handleClose?.();
        if (noteType === noteEnums?.OFFICE_NOTES) {
            open(
                <CreateAppFormNote
                    info={item}
                    apptId={apptId}
                    noteType={noteEnums?.OFFICE_NOTES}
                />, {
                    styles: { bodyStyle: { padding: '24px 48px' } },
                },
            );
        } else {
            open(
                <CreateAppSessionNote
                    appt={currentAppt}
                    info={item}
                    noteType={noteEnums?.CLINICAL_NOTES}
                    serviceTemplate={serviceTemplate}
                />, {
                    styles: { bodyStyle: { padding: '24px 48px' } },
                },
            );
        }
    };

    const handleDelete = (handleClose) => {
        handleClose?.();
        open(
            <CustomDelete
                info="Are you sure you want to delete this note?"
                text="Once deleted, this note will be permanently lost."
                handleDel={() => dispatch(appointmentActions.deleteApptNote(apptId, item?.id, item?.type))}
                actionType={DELETE_ACTION_TYPE}
                body={
                    <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                        <img style={{ marginTop: '3px' }} src={Images.editBlack} alt="icon" />
                        <p style={{ fontWeight: 400 }}>{item?.template?.title}</p>
                    </div>
                }
            />,
        );
    };

    const requestUpdate = (handleClose) => {
        handleClose?.();
        open(<RequestNoteUpdate afterSuccess={afterSuccess} info={item} apptId={apptId} single={single} />);
    };

    const remindUpdateNote = () => {
        const body = {
            noteId: item?.id,
            type: remindEnums.UPDATE_NOTE,
        };
        setRemindId(item?.id);
        dispatch(appointmentActions.remindApptNote(apptId, body));
    };

    const handleDownloadPdf = async (handleClose) => {
        if (pdfLoading || !apptId || !item?.id || !item?.type) return;

        setPdfLoading(true);
        try {
            const response = await axios({
                url: `/appt/${apptId}/downloadNote/${item.id}/${item.type}`,
                method: 'GET',
                responseType: 'blob',
                auth: true,
            });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${item?.template?.title || 'note'}.pdf`);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            handleClose?.();
        } catch (e) {
            console.error('Failed to generate PDF', e);
        } finally {
            setPdfLoading(false);
        }
    };

    const hasActiveRequest = item?.requestedDate && !item?.resolvedDate;
    const isCreator = item?.creatorId === userInfo?.id;
    // The request-update workflow (Request Update / Remind) is session-note-only —
    // office/general notes have no status workflow, so never expose it for them.
    const isSessionNote = noteType === noteEnums?.CLINICAL_NOTES;
    const canRequestUpdate =
        isSessionNote &&
        item?.creatorId !== userInfo?.id &&
        RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) &&
        item?.status !== noteStatusEnums.DRAFT &&
        item?.status !== noteStatusEnums.UPDATE_REQUEST;

    return (
        <div className={'flex-align-center'} style={{ gap: '8px', flexDirection: reverse ? 'row-reverse' : 'row' }}>
            {/* Status indicators outside the popover */}
            <>
                {/*{hasActiveRequest ? (*/}
                {/*    <div className="flex-align-center" style={{ gap: 12 }}>*/}
                {/*        {isCreator ? (*/}
                {/*            <SimpleTooltip*/}
                {/*                title={*/}
                {/*                    <div>*/}
                {/*                        <p*/}
                {/*                            style={{ marginBottom: 4 }}*/}
                {/*                        >{`Requested by ${item?.requestedBy} on ${moment(item?.requestedDate).format('MM/DD/YY [at] hh:mm A')}`}</p>*/}
                {/*                        <p>{`Message: ${item?.requestedMessage ? item?.requestedMessage : 'No Message'}`}</p>*/}
                {/*                    </div>*/}
                {/*                }*/}
                {/*                arrow*/}
                {/*                placement="top"*/}
                {/*            >*/}
                {/*                <div className="pending-update-box">Pending Update</div>*/}
                {/*            </SimpleTooltip>*/}
                {/*        ) : (*/}
                {/*            <SimpleTooltip*/}
                {/*                title={*/}
                {/*                    <div>*/}
                {/*                        <p*/}
                {/*                            style={{ marginBottom: 4 }}*/}
                {/*                        >{`Requested by ${item?.requestedBy} on ${moment(item?.requestedDate).format('MM/DD/YY [at] hh:mm A')}`}</p>*/}
                {/*                        <p>{`Message: ${item?.requestedMessage ? item?.requestedMessage : 'No Message'}`}</p>*/}
                {/*                    </div>*/}
                {/*                }*/}
                {/*                arrow*/}
                {/*                placement="top"*/}
                {/*            >*/}
                {/*                <div className="requested-on">*/}
                {/*                    <img src={Images.greenMark} alt="mark" />*/}
                {/*                    <p>{`Requested on ${moment.utc(item?.requestedDate).format('MM/DD/YY')}`}</p>*/}
                {/*                </div>*/}
                {/*            </SimpleTooltip>*/}
                {/*        )}*/}
                {/*    </div>*/}
                {/*) :*/}
                {/*{*/}
                {/*    item?.resolvedDate &&*/}
                {/*        <div className="requested-on">*/}
                {/*            <img src={Images.greenMark} alt="mark" />*/}
                {/*            <p>{`Resolved`}</p>*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*)}*/}
            </>

            {/* ManageActions popover with all actions */}
            <ManageActions
                actionType={REMIND_NOTE_ACTION_TYPE}
                styleBodyItems={{ padding: 0, width: 200 }}
                btnIcon={Images.moreGrayIcon}
                btnClass={'edit-btn-box'}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                renderBody={(handleClose) => (
                    <div>
                        {/* Download PDF */}
                        <button
                            className="authorization-action-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadPdf(handleClose);
                            }}>
                            {pdfLoading ? (
                                <MinLoader margin={'0'} color={'#0C66E4'} position="relative" />
                            ) : (
                                <img src={Images.downloadCloud} alt="download" />
                            )}
                            <p>Download PDF</p>
                        </button>

                        {/* Edit / Review */}
                        {!canEdit && (
                            <button
                                className="authorization-action-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(handleClose);
                                }}>
                                <img src={Images.edit} alt="edit" />
                                <p>{item?.status === noteStatusEnums.IN_REVIEW ? 'Review' : 'Edit'}</p>
                            </button>
                        )}

                        {/* Delete */}
                        {!canEdit && (
                            <button
                                className="authorization-action-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(handleClose);
                                }}>
                                <img src={Images.redTrash} alt="delete" />
                                <p>Delete</p>
                            </button>
                        )}

                        {/* Request Update — only when no active request and user has permission */}
                        {!hasActiveRequest && canRequestUpdate && (
                            <button
                                className="authorization-action-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    requestUpdate(handleClose);
                                }}>
                                <img src={Images.messageEdit} alt="request" />
                                <p>Request Update</p>
                            </button>
                        )}


                        <button
                            className="authorization-action-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                open(<NoteHistoryModal noteId={item?.id} />);
                            }}>
                            <img src={Images.showEye} alt="delete" />
                            <p>View History</p>
                        </button>


                        {/* Remind — session notes only, when there's an active request and user is not creator */}
                        {isSessionNote && hasActiveRequest && !isCreator && RolePermission([PermissionList.APPT_UPDATE_NOTES?.code]) && (
                            <button
                                className="authorization-action-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    remindUpdateNote();
                                }}>
                                {loadRequestRemind?.length && remindId === item?.id ? (
                                    <MinLoader margin={'0'} color={'#0C66E4'} position="relative" />
                                ) : (
                                    <img src={Images.edit} alt="remind" />
                                )}
                                <p>Remind</p>
                            </button>
                        )}
                    </div>
                )}
            />
        </div>
    );
};
